var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 6C7.78125 3.79086 9.67005 2 12 2C14.33 2 16.2188 3.79086 16.2188 6V7.06667H18.6711C20.0736 7.06667 21.1578 8.19411 20.9811 9.46874L19.5027 20.1354C19.355 21.2012 18.3653 22 17.1927 22H6.80728C5.63469 22 4.64503 21.2012 4.49732 20.1354L3.0189 9.46874C2.84224 8.19411 3.92644 7.06667 5.32886 7.06667H7.78125V6ZM12 3.6C10.602 3.6 9.46875 4.67452 9.46875 6V7.06667H14.5313V6C14.5313 4.67452 13.398 3.6 12 3.6ZM7.5 13.0072C7.5 14.5338 9.30874 16.1484 10.6328 17.1258C11.2322 17.5682 11.5319 17.7895 12 17.7895C12.4681 17.7895 12.7678 17.5682 13.3672 17.1258C14.6913 16.1484 16.5 14.5338 16.5 13.0072C16.5 10.4569 14.0249 9.50471 12 11.4748C9.97507 9.50471 7.5 10.4569 7.5 13.0072Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingWedding);
export default __webpack_public_path__ + "static/media/shopping-wedding.3045aa6372bb549c2ea0f2135cf531af.svg";
export { ForwardRef as ReactComponent };